import React from 'react'
import { Icon } from '../Icon';

const CustomRadio = (props) => {
    return (
        <div>
            {props.label &&
                <label className={`mb-1 e-text-raisin-black e-alt-font-noto-sans e-font-weight-400 line-height-18px e-font-14 pb-2`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-lust'>*</span>
                    }
                </label>
            }
            <div className={`${props.gap ? props.gap : " gap-4"} ${props.className ?? ""} d-flex `}>
                {props.data.map((data, index) => (
                    <div key={index} className='d-flex align-items-center gap-1 cursor-pointer'
                        onClick={() => props.onClick(data.id)}>
                        <Icon icon={props.selected === data.id ? "radio-active" : "radio-inactive"}
                            className="d-flex"
                            size={20} />
                        <p className='mb-0 e-alt-font-noto-sans e-text-raisin-black e-font-16 e-font-weight-400 line-height-24px'>
                            {data.label}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CustomRadio;
